import { Checkbox } from "@mui/material";
import PropTypes from "prop-types";

const SelectionRowCheckbox = ({ rowId, selectedRows, onChange }) => (
  <Checkbox
    checked={selectedRows.some((r) => r.id === rowId)}
    onChange={(e) => onChange(e.target.checked)}
    onClick={(e) => e.stopPropagation()}
    sx={{
      "&.Mui-checked": {
        color: "#403C6F",
        "& .MuiSvgIcon-root": { fill: "#403C6F" },
      },
    }}
  />
);


SelectionRowCheckbox.propTypes = {
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedRows: PropTypes.array,
  onChange: PropTypes.func,
};

export default SelectionRowCheckbox;
